import type { OnDestroy } from '@angular/core';
import { ChangeDetectorRef, Component, Input, inject } from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-fm-loading-page',
  templateUrl: './fm-loading-page.component.html',
  styleUrls: ['./fm-loading-page.component.scss'],
})
export class FmLoadingPageComponent implements OnDestroy {
  public currentTimeout: any;
  public isDelayedRunning = false;
  private cdr = inject(ChangeDetectorRef);

  @Input()
  public delay = 300;

  @Input()
  public set isRunning(value: boolean) {
    if (!value) {
      this.cancelTimeout();
      this.isDelayedRunning = false;
      this.cdr.markForCheck();
      return;
    }

    if (this.currentTimeout) {
      return;
    }

    this.currentTimeout = setTimeout(() => {
      this.isDelayedRunning = value;
      this.cancelTimeout();
      this.cdr.markForCheck();
    }, this.delay);
  }

  private cancelTimeout(): void {
    clearTimeout(this.currentTimeout);
    this.currentTimeout = undefined;
  }

  ngOnDestroy(): any {
    this.cancelTimeout();
  }
}
